"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropzoneContainer = exports.DropzoneLabelWrapper = void 0;
var Box_1 = __importDefault(require("@mui/material/Box"));
var styled_1 = __importDefault(require("@mui/material/styles/styled"));
var general_1 = require("utils/general");
exports.DropzoneLabelWrapper = (0, styled_1.default)(Box_1.default, { shouldForwardProp: (0, general_1.omitProps)('isAcceptedFile, isRejectedFile') })(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme, isAcceptedFile = _a.isAcceptedFile, isRejectedFile = _a.isRejectedFile;
    return ({
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%',
        overflow: 'hidden',
        padding: theme.spacing(6),
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.grey[600],
        backgroundColor: isAcceptedFile ? theme.palette.grey[400] : theme.palette.common.white,
        cursor: isRejectedFile ? 'not-allowed' : 'pointer',
        border: "2px dashed ".concat(isRejectedFile ? (_b = theme.palette.red) === null || _b === void 0 ? void 0 : _b.main : (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.main),
        ':hover, :focus': {
            backgroundColor: (_d = theme.palette.neutral) === null || _d === void 0 ? void 0 : _d.light,
        },
    });
});
exports.DropzoneContainer = (0, styled_1.default)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: 8,
        margin: theme.spacing(2, 0),
        ':focus-visible': __assign({}, theme.focusVisibleStyles),
    });
});
